import {
  DefaultsState,
  ProfileStates,
  SavedSearches,
  SearchResult,
  SortOption,
} from 'lib/search/reducers';
import { SearchTerm } from '../types';

export const CLEAR_DATA = 'SEARCH/CLEAR_DATA';
export const CLEAR_RESULTS = 'SEARCH/CLEAR_RESULTS';
export const CLEAR_DEFAULTS = 'SEARCH/CLEAR_DEFAULTS';
export const LOAD_DATA_CHUNK = 'SEARCH/LOAD_DATA_CHUNK';
export const HIDE_VISIBLE = 'SEARCH/HIDE_VISIBLE';
export const HIDE_VISIBLE_ALL = 'SEARCH/HIDE_VISIBLE_ALL';
export const UNTICK_ALL = 'SEARCH/UNTICK_ALL';
export const COPY_TICKED = 'SEARCH/COPY_TICKED';
export const COPY_VISIBLE_ALL = 'SEARCH/COPY_VISIBLE_ALL';
export const MOVE_TICKED = 'SEARCH/MOVE_TICKED';
export const MOVE_VISIBLE_ALL = 'SEARCH/MOVE_VISIBLE_ALL';
export const CHANGE_TICKED_ARTIST = 'SEARCH/CHANGE_TICKED_ARTIST';
export const UPDATE_SEARCH_ID = 'SEARCH/UPDATE_SEARCH_ID';
export const UPDATE_SEARCH_MATCHES = 'SEARCH/UPDATE_SEARCH_MATCHES';
export const UPDATE_PROFILE_STATE = 'SEARCH/UPDATE_PROFILE_STATE';
export const UPDATE_DEFAULT_SLOT = 'SEARCH/UPDATE_DEFAULT_SLOT';
export const UPDATE_SHOW_RECENT_PHOTO = 'SEARCH/UPDATE_SHOW_RECENT_PHOTO';
export const SET_SORT = 'SEARCH/SET_SORT';
export const UPDATE_MAX_RESULTS = 'SEARCH/UPDATE_MAX_RESULTS';
export const UPDATE_INCLUDE_INACTIVE = 'SEARCH/UPDATE_INCLUDE_INACTIVE';
export const ADD_SEARCH_TERM = 'SEARCH/ADD_TERM';
export const SET_SEARCH_TERMS = 'SEARCH/SET_TERMS';
export const REMOVE_SEARCH_TERM = 'SEARCH/REMOVE_TERM';
export const UPDATE_SEARCH_TERM = 'SEARCH/UPDATE_TERM';
export const SET_MATCHES = 'SEARCH/SET_MATCHES';
export const SET_OFFSET = 'SEARCH/SET_OFFSET';
export const SET_LOADING = 'SEARCH/LOADING';
export const SAVE_SEARCH = 'SEARCH/SAVE';
export const LOAD_SAVED_SEARCHES = 'SEARCH/LOAD_SAVED_SEARCHES';
export const DELETE_SEARCH = 'SEARCH/DELETE';
export const LOAD_SEARCH_TERMS = 'SEARCH/LOAD_TERMS';
export const RESTORE_HIDDEN = 'SEARCH/RESTORE_HIDDEN';

export function clearData() {
  return {
    type: CLEAR_DATA,
  };
}
export function clearResults() {
  return {
    type: CLEAR_RESULTS,
  };
}
export function clearDefaults() {
  return {
    type: CLEAR_DEFAULTS,
  };
}

export function loadDataChunk(artists: SearchResult[]) {
  return {
    type: LOAD_DATA_CHUNK,
    artists,
  };
}

export function hideVisibleAll() {
  return {
    type: HIDE_VISIBLE_ALL,
  };
}

export function hideVisible(artist: SearchResult) {
  return {
    type: HIDE_VISIBLE,
    artist,
  };
}
export function restoreHiddenArtists() {
  return {
    type: RESTORE_HIDDEN,
  };
}

export function untickAll() {
  return {
    type: UNTICK_ALL,
  };
}

export function copyTicked(tickedArtists: number[]) {
  return {
    type: COPY_TICKED,
    tickedArtists,
  };
}

export function copyVisibleAll() {
  return {
    type: COPY_VISIBLE_ALL,
  };
}

export function moveTicked(tickedArtists: number[]) {
  return {
    type: MOVE_TICKED,
    tickedArtists,
  };
}

export function moveVisibleAll() {
  return {
    type: MOVE_VISIBLE_ALL,
  };
}

export function changeTickedArtist(artist: SearchResult) {
  return {
    type: CHANGE_TICKED_ARTIST,
    artist,
  };
}

export function updateSearchId(searchId: number) {
  return {
    type: UPDATE_SEARCH_ID,
    searchId,
  };
}

export function updateSearchMatches(matches: number) {
  return {
    type: UPDATE_SEARCH_MATCHES,
    matches,
  };
}
export const updateProfileState = (reference: string, value: boolean) => ({
  type: UPDATE_PROFILE_STATE,
  reference,
  value,
});

export const updateDefaultSlot = (tagId: string) => ({
  type: UPDATE_DEFAULT_SLOT,
  tagId: parseInt(tagId),
});

export function updateShowRecentPhoto(value: boolean) {
  return { type: UPDATE_SHOW_RECENT_PHOTO, value };
}

export function setSort(sort: SortOption) {
  return { type: SET_SORT, sort };
}

export function updateMaxResults(maxResults: number | void) {
  return { type: UPDATE_MAX_RESULTS, maxResults };
}

export function updateIncludeInactive(includeInactive: boolean) {
  return { type: UPDATE_INCLUDE_INACTIVE, includeInactive };
}

export function addTerm(term: SearchTerm) {
  return { type: ADD_SEARCH_TERM, term };
}
export function setTerms(terms: SearchTerm[]) {
  return { type: SET_SEARCH_TERMS, terms };
}

export function updateTerm(termID: string, values: Partial<SearchTerm>) {
  return { type: UPDATE_SEARCH_TERM, values, termID };
}

export function removeTerm(termID: string) {
  return { type: REMOVE_SEARCH_TERM, termID };
}

export function setMatches(matches: number) {
  return { type: SET_MATCHES, matches };
}

export function setOffset(offset: number) {
  return { type: SET_OFFSET, offset };
}

export function setLoading(loading: boolean) {
  return { type: SET_LOADING, loading };
}

export function saveCurrentSearch(
  name: string,
  terms: SearchTerm[],
  profileStates: ProfileStates,
  defaults: DefaultsState,
  searchIdentifier: string,
) {
  return {
    type: SAVE_SEARCH,
    id: searchIdentifier,
    name,
    terms,
    profileStates,
    defaults,
  };
}

export function loadSavedSearches(searches: SavedSearches) {
  return {
    type: LOAD_SAVED_SEARCHES,
    searches: searches,
  };
}

export function deleteSavedSearch(id: string) {
  return { type: DELETE_SEARCH, id };
}

export function loadSavedSearch(
  terms: SearchTerm[],
  profileStates: ProfileStates,
  defaults: DefaultsState,
) {
  return { type: LOAD_SEARCH_TERMS, terms, profileStates, defaults };
}
